import { LitElement, html } from 'lit';
import './fit-fav-count';
import './fit-fav-list';
import '../fit-overlay/fit-overlay';

import styles from './fit-fav-dropdown.css';

class FitFavDropDown extends LitElement {
  static get is() { return 'fit-fav-dropdown'; }

  static get styles() { return styles; }

  render() {
    return html`
        <button id="trigger" @click="${this.onTriggerClick}">
          <slot name="trigger"></slot>
          <fit-fav-count style="width:24px; height:24px; "></fit-fav-count>
        </button>
        ${this.opened ? html`
          <fit-overlay opened @fit-overlay-closed="${this.onOverlayClose}">
            <fit-fav-list>
              <slot name="empty-list"></slot>
            </fit-fav-list>
          </fit-overlay>
        ` : ''}
     `;
  }

  static get properties() {
    return {
      opened: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  constructor(props) {
    super(props);
    this.opened = false;
    this._openedDebouncing = false;
  }

  onTriggerClick(event) {
    event.preventDefault();
    if (this._openedDebouncing) {
      return;
    }
    this.opened = !this.opened;
  }

  onOverlayClose() {
    this._openedDebouncing = true;
    this.opened = false;
    setTimeout(() => { this._openedDebouncing = false; });
  }
}

customElements.define(FitFavDropDown.is, FitFavDropDown);
